export const investmentTypeDescription = {
  'homepage.search.investment_types.property_investment.title': 'homepage.search.investment_types.property_investment.description',
  'homepage.search.investment_types.lp_investment.title': 'homepage.search.investment_types.lp_investment.description'
}
